import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Tutorials = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Tutorials | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Tutorials"
        content="The Conference"
        contentTwo="Tutorials"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        {/* <h4>To be released.</h4> */}
        <div className="entry-content">

        {/* <h2 id="tutorial1">Evolutionary Deep Learning for Image Classification:
        A Genetic Programming Approach</h2>
        <br></br>
                  <p className="home-p text-justify">
                  <h4>Abstract</h4>

          Image classification is an important and fundamental task in machine learning
and computer vision with a wide range of important applications, such as recognising
faces from photographs, detecting cancers from X-ray images, and classifying fish
species from underwater images. Many computational intelligence approaches have
been developed for image classification. Deep learning, particularly deep convolutional
neural networks (CNNs), is a dominant approach to image classification. Evolutionary
deep learning is an emerging topic that studies the combinations of evolutionary
computation (EC) and deep learning. This topic becomes more and more popular in
recent years and EC has shown great potential in this field by achieving better
performance than many manually designed CNNs. Genetic programming (GP) is a
promising approach to automatic programming using a variable-length representation. Its ability in learning different types of models has been verified in successfully solving
many tasks, including symbolic regression, classification, feature construction, scheduling, and image analysis. However, the potential of GP in learning deep models
has seldom been recognised and systematically summarised. Therefore, we will deliver
a tutorial on GP for evolving deep models with a special focus on solving image
classification tasks. 
<br></br>
In this tutorial, we will introduce the task of image classification and traditional
algorithms. An overview of deep learning and evolutionary deep learning, including
concepts, representative deep models and summaries of limitations, will be provided. We will introduce the definition of evolutionary computation and the GP algorithm, and
justify why and how GP can be used to evolve deep models. Existing works on using
GP to evolve deep models for image classification will be summarised and categorized. The main tutorial will focus on discussing existing work on using GP to evolve neural
network-based models and non-neural network-based models. Particularly, it will
introduce a series of GP algorithms for evolving deep models for binary classification, feature extraction, selection and construction, and ensemble classification. Recent
advanced topics such as improving computational efficiency, multitask learning and
transfer learning, and evolving deep models for other tasks will be also included in this
tutorial. We will show the potential of GP in the above aspects by providing methods
with promising classification results. We hope this tutorial will flourish the field of
evolutionary deep learning and attract more researchers and students over the world to
conduct research on this topic and further explore the potential of different types of
evolutionary deep learning techniques.
            <br></br>
            <br></br>
            <h4>Topic Overview</h4>
            This tutorial contains the following eight parts:
            <br></br>
(1) Introduction of image classification
<li> Image classification task definition, applications, and main challenges</li>
<li> General procedure to deal with image classification</li>
(2) Introduction of deep learning and evolutionary deep learning
<li> Concepts of deep learning and typical models</li>
<li> Limitations of deep learning methods</li>
<li> The definition/description of evolutionary computation</li>
<li> Concepts of evolutionary deep learning and categories of existing methods</li>
(3) Introduction of genetic programming
<li> Basic concepts of genetic programming</li>
<li> Why genetic programming is an evolutionary deep learning method?</li>
<li> Advantages of genetic programming</li>
(4) Evolving deep neural-network-based models
<li> Evolving CNNs</li>
(5) Evolving deep models of classifiers from images
<li> Genetic programming for image classification</li>
<li> Two-tier genetic programming</li>
<li> Three-tier genetic programming</li>
<li> HOG+GP</li>
<li> Multi-layer genetic programming</li>
(6) Genetic programming with deep structures for image feature extraction, selection
and construction
<li> Feature extraction, feature selection, feature construction, and feature learning</li>
<li> Genetic programming with convolutional and pooling filters</li>
<li> Genetic programming for global and/local feature learning</li>
<li> Genetic programming for feature learning from low-quality images</li>
<li> Genetic programming with flexible model structures</li>
<li> Genetic programming with feature reuse</li>
(7) Recent advances in genetic programming for evolving deep models
<li> Evolving deep models of ensembles</li>
<li> Improving computational efficiency</li>
<li> Transfer learning and multitask learning</li>
<li> Learning from a small number of training images</li>
<li> Examples of evolving deep models for other tasks</li>

(8) Conclusions and future directions
<li> Summary of existing studies in this field</li>
<li> Potential research directions for future study</li>
<br></br>
<h4>Speakers</h4>
<br></br>
          <p text-align="center">
              <img src="images/avatar/Yingbi.png" alt="Ying Bi" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Dr Ying Bi</div>
                Victoria University of Wellington, New Zealand.
              </strong>
            </p>

            <p>Ying Bi is a postdoctoral research fellow with the School of Engineering
and Computer Science at Victoria University of Wellington (VUW), New Zealand. Her research focuses mainly on computer vision, image
analysis, machine learning, deep learning, evolutionary computation, genetic programming, classification, feature learning, and transfer
learning. She has published an authored book on genetic programming
for image classification and over 50 papers in fully refereed journals and conferences in
computer vision and evolutionary computation. She has been serving as a workshop chair
of IEEE CEC 2024, student affair co-chair of GECCO 2024, 2023, an organizing
committee member of ECOLE 2022, IEEE CEC 2019 and Australasian AI 2018, an
organizer of a workshop in IEEE ICDM 2023, 2022, 2021, the symposium in IEEE SSCI
2023, 2022, a special session in IEEE SSCI 2021 and a special session in IDEAL 2021, and
a program committee member of over twenty international conferences including IJCAI, GECCO, IEEE CEC, IEEE SSCI, and Australasian AI. She was co-chair Poster session in
IEEE CEC 2019. She is serving as a reviewer of over twenty international journals. She is a
member of IEEE, IEEE Computational Intelligence Society (CIS) and ACM SIGEVO.0</p>
<br></br>
            <p text-align="center">
              <img src="images/avatar/Pingxue.png" alt="Ping Xue" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Prof. Bing Xue</div>
                Victoria University of Wellington, New Zealand
              </strong>
            </p>
            <p>Bing Xue is currently a Professor of Artificial Intelligence and Deputy
Head of School in the School of Engineering and Computer Science at
VUW. She has over 300 papers published in fully refereed international
journals and conferences and her research focuses mainly on
evolutionary computation, data mining, machine learning, classification, symbolic regression, feature selection, evolving deep neural networks, image analysis, transfer learning, multi-objective machine learning. Dr
Xue is currently the Chair of IEEE CIS Task Force on Transfer Learning
& Transfer Optimization, and Vice-Chair of IEEE Task Force on Evolutionary Feature
Selection and Construction and of IEEE CIS Task Force on Evolutionary Deep Learning
and Applications. She was the Chair of IEEE CIS Data Mining and Big Data Analytics
Technical Committee.
<br></br> 
Prof Xue is the organizer of the special session on Evolutionary Feature Selection and
Construction in IEEE CEC 2015, 2016, 2017, 2018, 2019, 2020, 2021 and 2022. Prof Xue
has been a chair for a number of international conferences including the Chair of
Women@GECCO 2018, a co-Chair of the Evolutionary Machine Learning Track for
GECCO 2019 and 2020, a co-Chair of the Neuroevolution Track for GECCO 2021 and
2022. She is the Lead Chair of IEEE Symposium on Computational Intelligence in Feature
Analysis, Selection, and Learning in Image and Pattern Recognition (FASLIP) at SSCI
2016, 2017, 2018, 2019 and 2020, a Program Chair of Australasian AI 2018, Finance Chair
of IEEE CEC 2019, a Workshop Chair of 2021 IEEE ICDM, a Conference Activities Chair
of IEEE SSCI 2021, a General Co-Chair of IVCNZ 2020, a Tutorial Co-Chair of IEEE
WCCI 2022, a Publication Co-Chair of EuroGP 2022, a conference Chairo f IEEE CEC
2024.She is an Editor of the IEEE CIS Newsletter. She is an Associate Editor or Member of the
Editorial Board for over ten international journals, including IEEE TEVC, IEEE CIM, IEEE
TAI, IEEE TETCI, and ACM TELO.</p>

            <p text-align="center">
              <img src="images/avatar/Mengjiezhang.png" alt="Mengjie Zhang" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Prof. Mengjie Zhang</div>
                Victoria University of Wellington, New Zealand.
              </strong>
            </p>
            <p>Mengjie Zhang is a Fellow of the Royal Society of New Zealand, a
Fellow of New Zealand Engineering, a Fellow of IEEE, an IEEE CIS
Distinguished Lecturer, and currently a Professor of Computer Science
at VUW, where he heads the interdisciplinary Evolutionary
Computation Research Group. He is a member of the University
Academic Board, a member of the University Postgraduate
Scholarships Committee, Associate Dean (Research and Innovation) in
the Faculty of Engineering, and Chair of the Research Committee of the Faculty of
Engineering and School of Engineering and Computer Science.
<br></br>
His research is mainly focused on evolutionary computation with the application areas of
feature selection/construction and dimensionality reduction, computer vision and image
processing, evolutionary deep learning and transfer learning, job shop scheduling, multi- objective optimization, and clustering and classification with unbalanced and missing data. Prof Zhang has published over 700 research papers in refereed international journals and
conferences in these areas.
</p>
          </p> */}
          <br></br>
          <hr></hr>


          <h3>DMBD Call for Tutorial Proposals</h3>
          <br></br>
          <p align="justify">
            DMBD 2024 will include tutorial sessions. Their
            aim is to provide a fast introduction to some topics of interest to
            the data mining and big data.{" "}
          </p>
          <p align="justify">
            Prospective organizers of tutorial sessions should submit proposals
            indicating:
          </p>
          <p align="left">
            * Title of the tutorial.
            <br />
            * Rationale of the need for the tutorial at DMBD.
            <br />
            * Short biography and recent photo of the organizers.
            <br />
          </p>
          <p align="justify">
            Proposals are due on or before August 22nd, 2024 and should be sent via e-mail (in either pdf or plain ASCII text form) to DMBD 2024 secretariat at{" "}
            <a href="mailto: dmbd2024@iasei.org">dmbd2024@iasei.org</a>
          </p>
          <p align="justify">
            Notification of acceptance will be sent to the organizers no later
            than August 31st, 2024.
          </p>
          <p>&nbsp;</p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
  }
  else {
    return (
      <React.Fragment>
      <SEO title="Tutorials | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Tutorials"
        content="The Conference"
        contentTwo="Tutorials"
        linkage="/"

      />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h4>To be released.</h4>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Tutorials;
